import React, { useEffect } from "react";

import { connect } from "react-redux";
import { addDataToMap, forwardTo } from "kepler.gl/actions";
import { Card, CardContent, Container } from "@mui/material";
import Kepler from "components/kleperMap/Kepler.component";
import { updateMap } from 'kepler.gl/actions';

const GeneralKeplerMapContainer = ({ zoom = 12, config, height, ...props }) => {
  const loadDataOnMap = (values) => {
    props.dispatch(addDataToMap(values));
    props.keplerGlDispatch(updateMap({ zoom: zoom }));
  };

  useEffect(() => {
    loadDataOnMap(config);
    // eslint-disable-next-line
  }, [config]);

  return (
    <Card
      sx={{
        border: "1px solid #E6DEB8",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent sx={{ "&.MuiCardContent-root": { padding: 0.5 } }}>
        <Card sx={{ padding: 0 }}>
          <Container maxWidth={false} style={{ padding: 0, maxHeight: height }}>
            <Kepler {...props} height={height} />
          </Container>
        </Card>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => state;
const dispatchToProps = (dispatch) => ({
  dispatch,
  keplerGlDispatch: forwardTo("map", dispatch)
});

export default connect(
  mapStateToProps,
  dispatchToProps
)(GeneralKeplerMapContainer);
